module.exports = __webpack_public_path__ + "img/stop-sign-exclusion.b846a22b.svg";